{
  "product": "岩旭企业邮箱",
  "connecting": "正在安全连接岩旭企业邮箱",
  "enterpriseSecurity": "企业级安全邮件服务",
  "hero": "让每一次沟通\n安全、清晰、高效",
  "heroText": "统一管理企业邮件、日程、联系人和文件，在任何设备上保持顺畅协作。",
  "encrypted": "全程加密传输 · 企业数据安全留存",
  "welcome": "欢迎回来",
  "loginTitle": "登录岩旭企业邮箱",
  "loginHint": "使用你的企业邮箱账号继续",
  "email": "邮箱地址",
  "password": "密码",
  "passwordPlaceholder": "请输入邮箱密码",
  "totp": "动态验证码（如已启用）",
  "totpPlaceholder": "6 位动态验证码",
  "sessionExpiry": "安全会话将在 12 小时后失效",
  "forgot": "忘记密码？",
  "login": "登录邮箱",
  "totpNote": "若账号已启用动态验证码，密码验证后将进入 TOTP 验证。",
  "privacy": "© 2026 岩旭软件 · 隐私政策 · 帮助中心",
  "showPassword": "显示密码",
  "hidePassword": "隐藏密码",
  "searchGlobal": "搜索邮件、联系人和附件",
  "write": "写邮件",
  "dashboard": "邮箱首页",
  "inbox": "收件箱",
  "starred": "星标邮件",
  "drafts": "草稿箱",
  "sent": "已发送",
  "archive": "归档",
  "junk": "垃圾邮件",
  "trash": "已删除",
  "apps": "应用",
  "contacts": "企业通讯录",
  "announcements": "公告通知",
  "attachments": "附件中心",
  "calendar": "日历与会议",
  "migration": "导入与导出",
  "settings": "个人设置",
  "capacity": "邮箱容量",
  "pending": "待接入",
  "capacityHint": "容量数据由邮件引擎提供",
  "toggleTheme": "切换明暗主题",
  "openNav": "打开导航",
  "logout": "退出登录",
  "search": "搜索",
  "all": "全部",
  "unread": "未读",
  "flagged": "星标",
  "attachment": "附件",
  "loadingMail": "正在加载邮件",
  "viaIMAP": "通过本机加密 IMAP 获取",
  "readFailed": "读取失败",
  "missingFolder": "未找到对应文件夹",
  "checkSpecial": "请检查 MOX special-use 文件夹配置",
  "emptyMail": "暂无邮件",
  "folderEmpty": "此文件夹目前为空",
  "selectMail": "选择一封邮件开始阅读",
  "secureRead": "邮件正文通过本机加密 IMAP 安全读取",
  "back": "返回",
  "delete": "删除",
  "createEvent": "创建日程",
  "reply": "回复",
  "replyAll": "全部回复",
  "forward": "转发",
  "download": "下载",
  "adminConsole": "管理控制台",
  "announcementAdmin": "公告管理",
  "storageAdmin": "存储管理",
  "migrationPolicy": "迁移策略",
  "systemAdmin": "系统管理",
  "adminConsoleTitle": "角色、安全、企业保留、审计和运行状态",
  "refresh": "刷新",
  "health": "运行状态",
  "retention": "企业保留",
  "roles": "角色权限",
  "security": "安全策略",
  "audit": "审计记录",
  "healthy": "正常",
  "needsCheck": "需要检查",
  "checking": "正在检查服务",
  "retentionTitle": "企业邮件保留",
  "retentionDays": "员工邮箱释放前的保留天数（留空表示永久）",
  "destructionDays": "归档后最终销毁天数（留空表示不自动销毁）",
  "trashPolicy": "垃圾箱可见副本清理",
  "destructionApprovals": "销毁审批人数",
  "oneAdmin": "一名管理员",
  "twoAdmins": "两名不同管理员",
  "retentionNotice": "归档会先写入并复验 SHA-256；验证成功后才允许释放员工副本。法务保全始终阻止销毁。",
  "saveRetention": "保存保留策略",
  "grantRole": "授予管理员角色",
  "existingAccount": "现有 MOX 邮箱账号",
  "grant": "授予角色",
  "revoke": "撤销",
  "securityTitle": "管理员与账号安全",
  "adminTotp": "管理员必须启用 TOTP",
  "privilegedRecovery": "高权限账号找回必须验证两个渠道",
  "anomalousRecovery": "异常登录找回必须验证两个渠道",
  "normalChannels": "普通账号可信渠道数",
  "privilegedChannels": "高权限账号可信渠道数",
  "anyOne": "任意一种",
  "anyTwo": "任意两种",
  "three": "三种",
  "saveSecurity": "保存安全策略",
  "auditChain": "安全审计链",
  "valid": "校验通过",
  "invalid": "校验失败",
  "appearance": "常规与外观",
  "readingList": "阅读与列表",
  "composeDraft": "写信与草稿",
  "rulesForward": "规则与转发",
  "identitySignature": "发件身份与签名",
  "accountSecurity": "账户与安全",
  "clientProtocol": "客户端与协议",
  "dataPrivacy": "数据与隐私",
  "language": "界面语言",
  "simplifiedChinese": "简体中文",
  "english": "English",
  "defaultPage": "登录后默认页面",
  "dashboardDefault": "邮箱首页仪表盘",
  "desktopLayout": "桌面邮件布局",
  "twoPane": "两栏",
  "threePane": "三栏",
  "followSystem": "跟随系统",
  "yanxuBlue": "岩旭蓝",
  "lightWhite": "明亮白",
  "darkNight": "深色夜间",
  "save": "保存",
  "cancel": "取消",
  "close": "关闭",
  "enabled": "已启用",
  "disabled": "未启用",
  "contactsTitle": "联系人",
  "contactsSubtitle": "个人联系人与企业员工目录",
  "newContact": "新建联系人",
  "searchContacts": "搜索姓名、邮箱、部门或公司",
  "personalContact": "个人联系人",
  "enterpriseEmployee": "企业员工",
  "emptyContacts": "通讯录为空",
  "calendarSubtitle": "个人日历、共享日历、会议邀请和提醒",
  "today": "今天",
  "month": "月",
  "list": "列表",
  "newEvent": "新建日程",
  "meetingRoom": "预约会议室",
  "calendarManage": "日历管理",
  "noEvents": "当前范围没有日程",
  "announcementSubtitle": "查看公司发布的重要通知",
  "noAnnouncement": "暂无企业公告",
  "announcementHint": "管理员发布后将在这里显示",
  "largeFile": "大附件分享",
  "largeFileSubtitle": "生成随机不可猜链接，可设置密码、有效期和下载次数",
  "chooseFile": "选择需要分享的文件",
  "createLink": "生成受保护链接",
  "myLargeFiles": "我的大附件",
  "migrationSubtitle": "安全迁移邮件，任务可恢复、可取消并保留完整结果",
  "importMail": "导入邮件",
  "exportMail": "导出邮件",
  "migrateOld": "迁移旧邮箱",
  "taskHistory": "任务记录",
  "noTasks": "暂无迁移任务",
  "loading": "正在加载",
  "saving": "正在保存…",
  "saved": "设置已保存",
  "errorGeneric": "请求失败，请稍后重试",
  "themeLabel": "主题",
  "vacationReply": "假期自动回复",
  "settingsSync": "界面设置跟随当前账号，在不同设备登录后自动同步。",
  "settingsSubtitle": "管理界面、收发邮件、签名与账户安全",
  "listDensity": "邮件列表密度",
  "allowBlockList": "黑白名单",
  "mailSubject": "邮件主题",
  "todaySchedule": "今日日程",
  "calendarReminder": "个人日程与会议提醒",
  "dashboardIndependent": "各独立文件夹的实时邮件数量",
  "dashboardUnread": "所有文件夹的实时未读统计",
  "dashboardShortcuts": "常用企业邮箱功能",
  "quickAccess": "快捷入口",
  "openInbox": "打开收件箱",
  "dragWidgets": "拖动卡片可排序，隐藏设置会保存到账号",
  "syncMailbox": "正在同步邮箱状态",
  "overview": "邮箱概览",
  "unreadMail": "未读邮件",
  "unreadSuffix": "封未读邮件",
  "refreshData": "刷新数据",
  "refreshJobs": "刷新任务",
  "collaborationCalendar": "协作日程",
  "noSchedule": "暂无日程",
  "noNotice": "暂无公告",
  "adminNotice": "系统管理员发布的企业公告",
  "companyInfo": "企业信息",
  "directoryLabel": "通讯录",
  "loadingContacts": "正在加载联系人",
  "directorySecure": "从岩旭通讯录安全读取",
  "createLarge": "创建大附件链接",
  "fileControlled": "文件存储在管理员配置的受控存储中",
  "expiry": "有效期",
  "maxDownloads": "最多下载次数",
  "optionalPassword": "访问密码（可选，至少 8 位）",
  "revokeEarly": "提前失效",
  "largeAttachment": "大附件",
  "dataMigration": "数据迁移",
  "fileImport": "从文件导入邮件",
  "fileSupport": "支持 EML、MBOX 和 Maildir ZIP；后台会检查容量、异常文件与重复邮件。",
  "fileFormat": "文件格式",
  "targetFolder": "目标文件夹",
  "chooseImport": "选择导入文件",
  "createImport": "创建导入任务",
  "safeRetry": "任务失败时可以安全重试，重复邮件不会再次写入",
  "p12Placeholder": "公告功能将在 P12 接入",
  "p13Placeholder": "日历功能将在 P13 接入",
  "currentShares": "仅显示当前账号创建的分享",
  "emptySubject": "（无主题）",
  "hello": "你好，",
  "youHave": "你有",
  "remindersSuffix": "个待提醒",
  "expiryPrefix": "到期：",
  "deleted": "已删除",
  "expired": "已失效",
  "validState": "有效",
  "downloaded": "已下载",
  "day1": "一",
  "day2": "二",
  "day3": "三",
  "day4": "四",
  "day5": "五",
  "day6": "六",
  "day7": "日",
  "searchMail": "搜索邮件",
  "searchSubtitle": "搜索结果直接定位并读取原始邮件",
  "searchResults": "搜索结果",
  "searchEmpty": "暂无搜索结果",
  "searchHint": "输入关键词后搜索当前文件夹",
  "selectResult": "选择结果查看原邮件",
  "noMoxJump": "不会跳转到 MOX 默认页面",
  "saveClose": "保存并关闭",
  "saveDraft": "保存草稿",
  "notSaved": "尚未保存",
  "sender": "发件人",
  "recipient": "收件人",
  "cc": "抄送",
  "bcc": "密送",
  "send": "发送",
  "addAttachment": "添加附件",
  "plainText": "纯文本",
  "name": "姓名",
  "company": "公司",
  "phone": "手机",
  "position": "职位",
  "department": "部门",
  "notes": "备注",
  "favoriteContact": "设为星标联系人",
  "saveContact": "保存联系人",
  "title": "标题",
  "location": "地点",
  "start": "开始",
  "end": "结束",
  "reminder": "提醒",
  "attendeeEmails": "参与人邮箱（多个地址用逗号分隔）",
  "description": "说明",
  "saveEvent": "保存日程",
  "calendarLabel": "日历",
  "optional": "（可选）",
  "mailFileImport": "邮件文件导入",
  "mailExport": "邮件导出",
  "oldIMAP": "旧邮箱 IMAP 迁移",
  "exportMine": "导出我的邮件",
  "exportNotice": "仅导出当前登录员工自己的文件夹，完成后生成 24 小时有效的下载文件。",
  "exportFormat": "导出格式",
  "chooseFolders": "选择文件夹",
  "exportPassword": "独立下载密码",
  "createExport": "创建导出任务",
  "migrateOther": "从其他邮箱迁移",
  "imapNotice": "仅使用加密 IMAPS 993；旧邮箱密码加密保存，任务终止后立即销毁。",
  "oldHost": "旧邮箱服务器",
  "oldAccount": "旧邮箱账号",
  "oldPassword": "旧邮箱密码或授权码",
  "continuous": "完成后限时持续同步",
  "startMigration": "开始迁移",
  "importAllTo": "全部邮件导入到",
  "tryLabel": "尝试",
  "completed": "已完成",
  "updatedAt": "· 更新于",
  "skipped": "已跳过",
  "imported": "已导入",
  "exported": "已导出",
  "mailSearchLabel": "邮件搜索",
  "mailboxField": "邮箱",
  "adminBackend": "管理员后台",
  "announcementManagement": "企业公告管理",
  "announcementPermission": "仅获得公告权限且已启用 TOTP 的管理员可以操作",
  "createAnnouncement": "创建公告",
  "announcementRecords": "公告记录",
  "noAnnouncementsYet": "尚无公告",
  "summary": "摘要",
  "level": "级别",
  "richBody": "安全富文本正文",
  "scheduledPublish": "定时发布",
  "pin": "置顶",
  "largeStoragePolicy": "大附件存储策略",
  "storageSubtitle": "查看当前存储后端和健康状态；切换配置通过受控重启生效",
  "currentUse": "当前使用",
  "localDisk": "服务器本地磁盘",
  "synologyNAS": "群晖 NAS 挂载目录",
  "configurable": "可配置",
  "healthyStatus": "状态：健康",
  "nonSensitive": "非敏感运行参数",
  "localNASDir": "本地或 NAS 目录",
  "notConfigured": "未配置",
  "configurationChange": "配置变更",
  "restartApplies": "受控重启后生效",
  "secretWarning": "访问密钥和 Secret 永远不会返回浏览器或写入审计日志。",
  "migrationAdminTitle": "导入导出与迁移策略",
  "migrationAdminSubtitle": "控制员工导出加密、持续同步期限和私网 IMAP 访问",
  "forceExportPassword": "强制所有员工导出文件设置独立密码",
  "allowContinuous": "允许管理员配置范围内的限时持续 IMAP 同步",
  "continuousMax": "最长持续同步天数",
  "allowPrivateIMAP": "允许连接私网 IMAP 地址（仅在可信网络环境启用）",
  "migrationCredentialNotice": "所有迁移仅使用 IMAPS 993。源邮箱密码使用主密钥加密，任务完成、失败或取消后销毁。",
  "savePolicy": "保存策略",
  "systemHealth": "系统健康",
  "twoChannels": "两种",
  "adminModules": "管理模块",
  "admin.totp.reset": "重置 TOTP",
  "admin.totp.confirm": "确认重置",
  "admin.totp.success": "已重置 TOTP 并撤销全部会话",
  "admin.totp.failure": "重置 TOTP 失败",
  "safeRichText": "安全富文本",
  "unifiedSignature": "统一签名",
  "companySignature": "公司统一签名",
  "signatureAllMail": "对所有发出邮件强制追加",
  "signatureHTMLTemplate": "安全富文本模板",
  "signatureTextTemplate": "纯文本模板",
  "signatureAllowImages": "允许签名图片",
  "signatureImageLimit": "图片上限（KB）",
  "signatureImageDimensions": "图片最大尺寸",
  "signatureHelp": "支持姓名、部门、职位和邮箱变量；系统会过滤脚本、表单、远程 CSS、嵌入框架和危险 HTML。",
  "signatureSave": "保存统一签名",
  "signatureSaved": "公司统一签名已保存",
  "totpReset": "重置 TOTP",
  "announcementSelect": "选择一条公告查看详情",
  "important": "重要",
  "adminNative1": "全部状态",
  "adminNative2": "失败",
  "adminNative3": "尚未检测",
  "adminNative4": "已取消",
  "adminNative5": "当前没有匹配的投递任务",
  "adminNative6": "当前没有投递尝试记录",
  "adminNative7": "投递中",
  "adminNative8": "排队中",
  "adminNative9": "收件域名",
  "adminNative10": "筛选",
  "adminNative11": "邮件运行中心",
  "adminNative12": "IP / 网段",
  "adminNative13": "允许",
  "adminNative14": "允许 / 拒绝规则",
  "adminNative15": "创建失败",
  "adminNative16": "创建规则",
  "adminNative17": "可安全下载",
  "adminNative18": "地址",
  "adminNative19": "域名",
  "adminNative20": "审批失败",
  "adminNative21": "已阻止下载",
  "adminNative22": "当前没有待处理的隔离邮件",
  "adminNative23": "拒绝",
  "adminNative24": "撤销失败",
  "adminNative25": "操作失败",
  "adminNative26": "无法读取安全数据",
  "adminNative27": "无法预览",
  "adminNative28": "本次操作原因（写入审计）",
  "adminNative29": "独立审批",
  "adminNative30": "确认从管理视图隐藏？",
  "adminNative31": "确认撤销该规则？",
  "adminNative32": "确认释放到员工收件箱？",
  "adminNative33": "管理员安全复核",
  "adminNative34": "规则对象",
  "adminNative35": "选择邮件查看经过过滤的安全预览",
  "adminNative36": "邮件隔离与安全规则",
  "adminNative37": "释放",
  "adminNative38": "隐藏",
  "adminNative39": "隔离邮件",
  "adminNative40": "需要第二名管理员审批",
  "adminNative41": "DKIM 密钥与轮换",
  "adminNative42": "DKIM 密钥轮换",
  "adminNative43": "变更原因（写入安全审计）",
  "adminNative44": "启用失败",
  "adminNative45": "启用密钥",
  "adminNative46": "已退役",
  "adminNative47": "待启用",
  "adminNative48": "新选择器",
  "adminNative49": "无法读取 DKIM 密钥",
  "adminNative50": "无法读取域名",
  "adminNative51": "更新失败",
  "adminNative52": "标记 DNS 已验证",
  "adminNative53": "标记 DNS 异常",
  "adminNative54": "生成下一把密钥",
  "adminNative55": "生成失败",
  "adminNative56": "私钥仅加密保存在服务器，界面和接口只显示需要发布的 DNS TXT 记录。",
  "adminNative57": "邮件域名",
  "adminNative58": "15 天",
  "adminNative59": "30 天",
  "adminNative60": "60 天",
  "adminNative61": "7 天",
  "adminNative62": "90 天",
  "adminNative63": "DKIM 密钥",
  "adminNative64": "企业保留策略已保存",
  "adminNative65": "保存失败",
  "adminNative66": "公司签名富文本模板",
  "adminNative67": "公司签名纯文本模板",
  "adminNative68": "安全策略已保存",
  "adminNative69": "异常",
  "adminNative70": "授权失败",
  "adminNative71": "无法读取管理数据",
  "adminNative72": "永久",
  "adminNative73": "签名图片最大宽度",
  "adminNative74": "签名图片最大高度",
  "adminNative75": "运行中心",
  "adminNative76": "隔离与规则",
  "adminNative77": "账号与别名",
  "adminNativeExtra1": "DNS 状态",
  "adminNativeExtra2": "TLS 证书",
  "adminNativeExtra3": "TLS 证书状态",
  "adminNativeExtra4": "关闭详情",
  "adminNativeExtra5": "取消投递任务",
  "adminNativeExtra6": "域名、DNS 与证书",
  "adminNativeExtra7": "尚未读取证书主题",
  "adminNativeExtra8": "当前没有域名 DNS 检测结果",
  "adminNativeExtra9": "当前没有已配置证书",
  "adminNativeExtra10": "投递任务",
  "adminNativeExtra11": "投递任务详情",
  "adminNativeExtra12": "投递日志",
  "adminNativeExtra13": "投递队列",
  "adminNativeExtra14": "操作原因",
  "adminNativeExtra15": "无到期时间",
  "adminNativeExtra16": "查看详情",
  "adminNativeExtra17": "正在加载…",
  "adminNativeExtra18": "正在提交…",
  "adminNativeExtra19": "没有收件人记录",
  "adminNativeExtra20": "状态",
  "adminNativeExtra21": "确认取消投递",
  "adminNativeExtra22": "确认执行",
  "adminNativeExtra23": "确认重试收件人",
  "adminNativeExtra24": "筛选投递队列",
  "adminNativeExtra25": "该操作会写入安全审计日志，请填写原因。",
  "adminNativeExtra26": "运行中心页面",
  "adminNativeExtra27": "重试",
  "connectionOffline": "离线",
  "task10UI1": "创建后的分享会显示在这里",
  "task10UI2": "收取邮件",
  "task10UI3": "新建任务后，真实进度会显示在这里",
  "task10UI4": "暂无大附件",
  "task10UI5": "暂时无法读取邮箱状态",
  "task10UI6": "正在识别邮件文件夹",
  "task10UI7": "请检查系统文件夹配置",
  "task10UI8": "通过 JMAP 定位原邮件",
  "task10UI9": "邮件正文通过 JMAP 安全读取",
  "等待 worker 处理": "等待 worker 处理",
  "quota.loading": "正在读取",
  "quota.loadingDetail": "正在读取容量数据",
  "dataPrivacy.loading": "正在读取数据策略"
}
